import {METHOD} from "services/method";

export const API_REVIEW = {
    LIST: {
        api: '/v1/dashboard-admin/review/list',
        method: METHOD.POST,
    },
    EXPORT: {
        api: '/v1/dashboard-admin/review/export',
        method: METHOD.POST,
    },
    DELETE: {
        api: '/v1/dashboard-admin/review/delete',
        method: METHOD.POST,
    },
    PRODUCT_REVIEW_LIST: {
        api: '/v1/dashboard-admin/review/product/list',
        method: METHOD.POST,
    },
    EXPORT_PRODUCT_REVIEW: {
        api: '/v1/dashboard-admin/review/product/export',
        method: METHOD.POST,
    },
    PRODUCT_REVIEW_STATISTIC: {
        api: '/v1/dashboard-admin/review/statistic',
        method: METHOD.GET,
    },
    PRODUCT_REVIEW_DETAIL: {
        api: '/v1/dashboard-admin/review/detail',
        method: METHOD.POST,
    },
    EXPORT_USER_REVIEW_LIST: {
        api: '/v1/dashboard-admin/review/detail/export',
        method: METHOD.POST,
    },
}
